// @flow

import { LocalStorage } from 'shared/utils';

export const ActionTypes = {
  TOGGLE_MAIN_MENU: 'TOGGLE_MAIN_MENU',
  QUEUE_ALERT_NOTIFICATION: 'QUEUE_ALERT_NOTIFICATION',
  REMOVE_ALERT_NOTIFICATION: 'REMOVE_ALERT_NOTIFICATION',
  MARK_TUTORIAL_TOOLTIP_SEEN: 'MARK_TUTORIAL_TOOLTIP_SEEN',
};

export type ActionPayload = $Shape<{
  type: $Keys<typeof ActionTypes>,
  data: any,
}>;

type GlobalState = {
  mainMenuOpen: boolean,
  alertNotifications: Object[],
  tutorialTooltips: string[],
};

const initialState = {
  mainMenuOpen: false,
  alertNotifications: [],
  tutorialTooltips: LocalStorage.get('tutorialTooltips', []),
};

export default function(
  state: GlobalState = initialState,
  action: ActionPayload,
): GlobalState {
  switch (action.type) {
    /**
     * Toggle the main menu in/out of view
     */
    case ActionTypes.TOGGLE_MAIN_MENU:
      return {
        ...state,
        mainMenuOpen: action.data,
      };

    /**
     * Add a notification into the alertNotifications stack
     */

    case ActionTypes.QUEUE_ALERT_NOTIFICATION:
      return {
        ...state,
        alertNotifications: [action.data].concat(state.alertNotifications),
      };

    /**
     * Remove a notification from the alertNotifications stack
     */
    case ActionTypes.REMOVE_ALERT_NOTIFICATION:
      return {
        ...state,
        alertNotifications: state.alertNotifications.filter(
          a => a.id !== action.data,
        ),
      };

    /**
     * Mark utorial tooltip as seen by adding it to the tutorialTooltips array
     */
    case ActionTypes.MARK_TUTORIAL_TOOLTIP_SEEN:
      return {
        ...state,
        tutorialTooltips: state.tutorialTooltips.concat(action.data),
      };
  }

  return state;
}
